import { listen, qs, qsa } from '@fluorescent/dom';

import { section } from '@/neon';

section('cart', {
  onLoad() {
    const form = qs('[data-form]', this.container);
    const buttons = qsa('[data-change]', this.container);

    let timer;

    this.buttonClick = listen(buttons, 'click', e => {
      e.preventDefault();
      const { change } = e.currentTarget.dataset;

      const input = qs('input', e.currentTarget.parentNode);

      if (change === 'increment') {
        input.value >= 0 && input.value++;
      } else if (change === 'decrement') {
        input.value > 0 && input.value--;
      }

      clearTimeout(timer);
      timer = setTimeout(() => {
        form.submit();
      }, 1000);
    });
  },

  onUnload() {
    this.buttonClick();
  },
});
